import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export class FileValidator {

  public static fileMaxSize = (maxSize: number): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null =>
      control?.value?.size
        ? ((control.value.size as number) / (1024 * 1024)) > maxSize ? { fileMaxSize: true } : null
        : control?.value?.file
          ? ((control.value.file.size as number) / (1024 * 1024)) > maxSize ? { fileMaxSize: true } : null
          : control?.value?.size
            ? ((control.value.size as number) / (1024 * 1024)) > maxSize ? { fileMaxSize: true } : null
            : null;
}